import { hero, toHub } from "../app.ts";
import { sfx } from "../audio.ts";
import { setScene } from "../engine.ts";
import { Actor } from "../render/actor.ts";
import { drawArena, GROUND } from "../render/arena.ts";
import { Fx } from "../render/fx.ts";
import { btn, h, mount } from "../ui/dom.ts";
import { muteButton } from "./common.ts";
import { titleScreen } from "./title.ts";

const CONFETTI = ["#f5c431", "#c62f24", "#2f6fd6", "#3f9a3a", "#ffffff"];

export function endingScreen(): void {
  const me = hero();
  const champ = new Actor(me.look, { ...me.gear, helmet: "crown" }, 1, 640);
  champ.state = "victory";
  const fx = new Fx();
  let nextBurst = 0;
  setScene((ctx, t, dt) => {
    drawArena(ctx, "summit", t, 1);
    champ.draw(ctx, t, GROUND + 20, 2.6);
    if (t > nextBurst) {
      nextBurst = t + 0.5;
      fx.feathers(200 + Math.random() * 880, 120 + Math.random() * 200, CONFETTI[Math.floor(Math.random() * CONFETTI.length)] ?? "#fff", 10);
    }
    fx.draw(ctx, t, dt);
  });

  mount(
    null,
    h(
      "div",
      { class: "ending" },
      h("h1", null, "Supreme Overlord of Earth"),
      h("div", { class: "sub" }, `All hail ${me.name}! The world is now one big coop.`),
    ),
    h(
      "div",
      { class: "ending-stats" },
      h("div", { class: "panel", style: { fontWeight: "900", fontSize: "20px" } }, `Level ${me.level} · ${me.wins} wins · ${me.losses} losses`),
      btn("Keep Fighting ▶", toHub, "green big"),
      btn("Title", titleScreen, "wood"),
    ),
    muteButton(),
  );
  sfx.fanfare();
  setTimeout(() => sfx.cheer(0.5), 600);
}
